var map = {
	"app/answer/answer.module": [
		"./src/app/answer/answer.module.ts",
		"app-answer-answer-module"
	],
	"app/answer/answertem.module": [
		"./src/app/answer/answertem.module.ts",
		"app-answer-answertem-module"
	],
	"app/authen/authen.module": [
		"./src/app/authen/authen.module.ts",
		"app-authen-authen-module"
	],
	"app/career/career-list/careerlist.module": [
		"./src/app/career/career-list/careerlist.module.ts",
		"app-career-career-list-careerlist-module"
	],
	"app/career/career.module": [
		"./src/app/career/career.module.ts",
		"app-career-career-module"
	],
	"app/cart/cart.module": [
		"./src/app/cart/cart.module.ts",
		"app-cart-cart-module"
	],
	"app/courses/courses.module": [
		"./src/app/courses/courses.module.ts",
		"app-courses-courses-module"
	],
	"app/courses/coursestem.module": [
		"./src/app/courses/coursestem.module.ts",
		"app-courses-coursestem-module"
	],
	"app/dengbao/dengbao.module": [
		"./src/app/dengbao/dengbao.module.ts",
		"app-dengbao-dengbao-module"
	],
	"app/exam/exam.module": [
		"./src/app/exam/exam.module.ts",
		"app-exam-exam-module"
	],
	"app/guide/guide.module": [
		"./src/app/guide/guide.module.ts",
		"app-guide-guide-module"
	],
	"app/home/authen-course-list/authenlist.module": [
		"./src/app/home/authen-course-list/authenlist.module.ts",
		"app-home-authen-course-list-authenlist-module"
	],
	"app/home/home.module": [
		"./src/app/home/home.module.ts",
		"app-home-home-module"
	],
	"app/home/safe.module": [
		"./src/app/home/safe.module.ts",
		"app-home-safe-module"
	],
	"app/job-teacher/jobt.module": [
		"./src/app/job-teacher/jobt.module.ts",
		"app-job-teacher-jobt-module"
	],
	"app/job/job.module": [
		"./src/app/job/job.module.ts",
		"app-job-job-module"
	],
	"app/message/message-template/messagetem.module": [
		"./src/app/message/message-template/messagetem.module.ts",
		"app-message-message-template-messagetem-module"
	],
	"app/message/message.module": [
		"./src/app/message/message.module.ts",
		"app-message-message-module"
	],
	"app/new-user/exclusive.module": [
		"./src/app/new-user/exclusive.module.ts",
		"app-new-user-exclusive-module"
	],
	"app/partcourse/partcourse.module": [
		"./src/app/partcourse/partcourse.module.ts",
		"app-partcourse-partcourse-module"
	],
	"app/partner/partner.module": [
		"./src/app/partner/partner.module.ts",
		"app-partner-partner-module"
	],
	"app/personal-center/pc.module": [
		"./src/app/personal-center/pc.module.ts",
		"app-personal-center-pc-module"
	],
	"app/teacher/teacher.module": [
		"./src/app/teacher/teacher.module.ts",
		"app-teacher-teacher-module"
	],
	"app/teacher/teachersim.module": [
		"./src/app/teacher/teachersim.module.ts",
		"app-teacher-teachersim-module"
	],
	"app/train-camp/traincamp.module": [
		"./src/app/train-camp/traincamp.module.ts",
		"app-train-camp-traincamp-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;